
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/analytics",
      function () {
        return require("private-next-pages/analytics.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/analytics"])
      });
    }
  